import styles from "./liveagent-logo-icon.module.css";

const LiveagentLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      {...props}
    >
      <path
        className={styles["liveagent-loading-u-outer-left"]}
        d="M6.31835,9.03387c-.16346-.28305-.30299-.58206-.42259-.88903C2.51901,10.2458,0.270508,13.9933,0.270508,18.2631s0,.0638,0,.0957h.976742c0-.0319,0-.0638,0-.0957c0-3.8791,2.02126-7.2877,5.0711-9.22923Z"
        opacity="0"
        fill="#ffa473"
      />
      <path
        className={styles["liveagent-loading-u-middle-left"]}
        d="M7.64586,10.6924c-.26711-.2392-.5103-.5024-.73754-.78542C4.13756,11.6571,2.29968,14.7429,2.29968,18.2631s0,.0638,0,.0957h1.05249c0-.0319,0-.0638,0-.0957c0-3.2172,1.72226-6.0319,4.29369-7.5707Z"
        opacity="0"
        fill="#ffd6bf"
      />
      <path
        className={styles["liveagent-loading-u-inner-left"]}
        d="M9.66317,11.9522c-.40266-.1595-.7814-.3588-1.1402-.5901-2.47176,1.3116-4.15017,3.907-4.15017,6.901s0,.0638,0,.0957h1.01661c0-.0319,0-.0638,0-.0957c0-2.8624,1.7701-5.3103,4.27775-6.3109h-.00399Z"
        opacity="0"
        fill="#fff"
      />
      <path
        className={styles["liveagent-loading-u-outer-right"]}
        d="M18.0433,9.03387c.1595-.28305.299-.58206.4186-.88903c3.3409,2.10096,5.5655,5.84846,5.5655,10.11826s0,.0638,0,.0957h-.9688c0-.0319,0-.0638,0-.0957c0-3.8791-2.0013-7.2877-5.0153-9.22923Z"
        opacity="0"
        fill="#ffa473"
      />
      <path
        className={styles["liveagent-loading-u-middle-right"]}
        d="M16.7277,10.6924c.2631-.2392.5063-.5024.7295-.78542c2.7389,1.75012,4.5608,4.83592,4.5608,8.35612s0,.0638,0,.0957h-1.0405c0-.0319,0-.0638,0-.0957c0-3.2172-1.7023-6.0319-4.2459-7.5707h-.0039Z"
        opacity="0"
        fill="#ffd6bf"
      />
      <path
        className={styles["liveagent-loading-u-inner-right"]}
        d="M14.7344,11.9522c.3986-.1595.7734-.3588,1.1282-.5901c2.4439,1.3116,4.1063,3.907,4.1063,6.901s0,.0638,0,.0957h-1.0046c0-.0319,0-.0638,0-.0957c0-2.8624-1.7502-5.3103-4.2299-6.3109Z"
        opacity="0"
        fill="#fff"
      />
      <path
        className={styles["liveagent-loading-u-circle-top"]}
        d="M12.1749,0C9.00543,0,6.43799,2.56744,6.43799,5.73688c0,.53422.11561,1.31561.32691,1.91761.11163.31096.24718.60996.40664.89302.17542.31096.37874.60199.60598.87309.23921.28704.5103.55017.80133.7854.32293.2631.67774.4864,1.05648.6737.76547.3788,1.63057.5941,2.54357.5941.9129,0,1.774-.2153,2.5435-.5941.3787-.1873.7295-.4146,1.0565-.6737.291-.23523.5621-.49836.8013-.7854.2272-.2711.4306-.56213.606-.87309.1594-.28306.295-.58206.4066-.89302.2113-.59801.3269-1.24386.3269-1.91761C17.9197,2.56744,15.3523,0,12.1828,0h-.0079Zm4.0425,8.10499c-.1874.31893-.4106.60996-.6618.87309-.295.30299-.6259.5701-.9927.78538-.6977.41464-1.5149.64984-2.384.64984s-1.6864-.2392-2.3841-.64984c-.36678-.21528-.69767-.48239-.99269-.78538-.25515-.26313-.47841-.55814-.6618-.87309-.16345-.27907-.299-.57808-.40664-.89303-.15548-.46644-.2392-.9608-.2392-1.47907c0-2.58737,2.09701-4.68438,4.68443-4.68438c2.5873,0,4.6843,2.09701,4.6843,4.68438c0,.47841-.0837,1.01263-.2392,1.47907-.1036.31495-.2392.60997-.4066.89303Z"
        fill="#fff"
      />
      <path
        className={styles["liveagent-loading-u-circle-bottom"]}
        d="M12.1749,12.5262c-3.16947,0-5.73691,2.5675-5.73691,5.7369c0,.7655.11561,1.3156.32691,1.9176.11163.311.24718.61.40664.8931.17542.3109.37874.6019.60598.873.23921.2871.5103.5502.80133.7854.32293.2632.67774.4864,1.05648.6738.76547.3787,1.63057.594,2.54357.594.9129,0,1.774-.2153,2.5435-.594.3787-.1874.7295-.4146,1.0565-.6738.291-.2352.5621-.4983.8013-.7854.2272-.2711.4306-.5621.606-.873.1594-.2831.295-.5821.4066-.8931.2113-.598.3269-1.2438.3269-1.9176c0-3.1694-2.5674-5.7369-5.7369-5.7369h-.0079Zm4.0425,8.109c-.1874.319-.4106.61-.6618.8731-.295.303-.6259.5701-.9927.7854-.6977.4146-1.5149.6498-2.384.6498s-1.6864-.2392-2.3841-.6498c-.36678-.2153-.69767-.4824-.99269-.7854-.25515-.2631-.47841-.5581-.6618-.8731-.16345-.2791-.299-.5781-.40664-.893-.15548-.4665-.2392-.9608-.2392-1.4791c0-2.5874,2.09701-4.6844,4.68443-4.6844c2.5873,0,4.6843,2.097,4.6843,4.6844c0,.5861-.0837,1.0126-.2392,1.4791-.1036.3149-.2392.61-.4066.893Z"
        fill="#fff"
      />
    </svg>
  );
};

export default LiveagentLogoIcon;
